import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../../../hooks/customDocumentTitleHook";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeDate, getPractice } from "../../../../helpers";
import { fetchSingleOlderCareForm } from "../../../../services/forms";

export default function OlderCarePrint({ ...props }) {
  const {    
    formViewId,
    formViewSize = "A4",
    setFormView = () => {}
  } = props;

  const [formData, setFormData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const navigate = useNavigate();
  const contentRef = useRef();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accountId = getPractice("account_id");
  const locationId = getPractice("location_id");

  let formId = formViewId;
  let formSize = formViewSize;
  if (queryParams.get('form_id')) {
    formId = queryParams.get('form_id');
    formSize = queryParams.get('size');
  } 

  useEffect(() => {
    if(formId !== null){
      getReferralData( formId );
    } else {
      navigate(-1);
    }
  }, [formId]);

  const getReferralData = async ( formId ) => {
    const response = await fetchSingleOlderCareForm( accountId, locationId, formId );
    if (response) {
      if(response.data === null) {
        window.close();
      }
      setFormData(response?.data);
      setIsDataLoaded(true);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    if (isDataLoaded && queryParams.get('form_id')) {
      handlePrint();
    }
  }, [isDataLoaded, queryParams]);

  const handleCloseWindow = () => {
    window.close();
  };

  const handleFormPrint = (formId) => {
    setFormView();
    const url = `/forms/older-care-form/print?form_id=${formId}&size=A4`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const pageSize = formSize == "A4" ? "A4" : "Letter";
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media print {
        @page {
          size: ${pageSize};
        }
      }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [formSize]);

  useDocumentTitle("Older Care Form");

  return (
    <div ref={contentRef} className="docpro_signout_wrap">
      <div className="docpro_signout">
        <div>
          <div>
            <h3 className="text-center fs-20 mb-3">Older Care Form</h3>
          </div>

          <h6>CARE FOR OLDER ADULTS ASSESSMENT FORM</h6>

          <div className="mx-0">
            <ul className="docpro_list_1 mb-2">
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 125 }}>Location</p><span className="mx-1">:</span> {formData?.location_id}
              </li>
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 125 }}>Last Name</p><span className="mx-1">:</span> {formData?.last_name}
              </li>
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 125 }}>First Name</p><span className="mx-1">:</span> {formData?.first_name}
              </li>
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 125 }}>Date of Birth</p><span className="mx-1">:</span> {exchangeDate(formData?.patient_dob)}
              </li>
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 125 }}>Assessment Date</p><span className="mx-1">:</span> {exchangeDate(formData?.patient_assessment_date)}
              </li>
            </ul>

            <h6 className="mb-2">FUNCTIONAL STATUS ASSESSMENT</h6>

            <span className="scheduler-border" style={{ fontSize: 16, fontWeight: 500, borderBottom: '1px solid' }}>Activities of Daily Living</span>

            <div className="mt-2">
              <div className="flex items-center" style={{ flexWrap: 'wrap' }}>
                <p className="mr-2 mb-0">Are you able to take care of yourself?</p>
                <input className="form-check-input mr-2" type="checkbox" checked={formData?.care_yourself == 1} disabled />
                <span className="pr-2 mr-2">Yes</span>
                <input className="form-check-input mr-2 pl-2" type="checkbox" checked={formData?.care_yourself == 0} disabled />
                <span>No</span>
              </div>

              <div className="mt-1">
                <p>If No, check all activities you need help with:</p>
                <div className="flex items-center" style={{ flexWrap: 'wrap' }}>
                  <input className="form-check-input" type="checkbox" checked={formData?.bathing == 1} disabled />
                  <span className="pr-2 mr-2">Bathing</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.dressing == 1} disabled />
                  <span className="pr-2 mr-2">Dressing</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.eating == 1} disabled />
                  <span className="pr-2 mr-2">Eating</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.shopping == 1} disabled />
                  <span className="pr-2 mr-2">Shopping</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.toileting == 1} disabled />
                  <span className="pr-2 mr-2">Toileting</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.walking == 1} disabled />
                  <span className="pr-2 mr-2">Walking</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.transferring == 1} disabled />
                  <span className="pr-2 mr-2">Transferring</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.transportation == 1} disabled />
                  <span className="pr-2 mr-2">Transportation</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.use_pho == 1} disabled />
                  <span className="pr-2 mr-2">Using phone</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.laundtry == 1} disabled />
                  <span className="pr-2 mr-2">Laundry</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.meal_pre == 1} disabled />
                  <span className="pr-2 mr-2">Meal preparation</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.t_medi == 1} disabled />
                  <span className="pr-2 mr-2">Taking Medications</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.other == 1} disabled />
                  <span>Others</span>
                </div>
              </div>
            </div>

            <h6 className="mb-2 mt-4">ADVANCE CARE PLANNING</h6>

            <p className="mr-2 mb-0">Have you discussed with your doctor what would happen if you are unable to make your own medical decisions?</p>
            <div className="flex items-center">
              <input className="form-check-input mr-2" type="checkbox" checked={formData?.u_tmd == 1} disabled />
              <span className="pr-2 mr-2">Yes</span>
              <input className="form-check-input mr-2 pl-2" type="checkbox" checked={formData?.u_tmd == 0} disabled />
              <span>No</span>
            </div>
            <p className="mb-1">Check all advance care planning you have in place:</p>
            <div className="flex items-center" style={{ flexWrap: 'wrap' }}>
              <input className="form-check-input" type="checkbox" checked={formData?.ad_dir == 1} disabled />
              <span className="pr-2 mr-2">Advance Directives</span>
              <input className="form-check-input" type="checkbox" checked={formData?.living_will == 1} disabled />
              <span className="pr-2 mr-2">Living Will</span>
              <input className="form-check-input" type="checkbox" checked={formData?.ac_medi_or == 1} disabled />
              <span>Actionable Medical Orders</span>
            </div>

            <h6 className="mb-2 mt-4">MEDICATION REVIEW</h6>

            <div className="flex items-center">
              <p className="mr-2 mb-0">Are you on any Medication(s):</p>
              <input className="form-check-input mr-2" type="checkbox" checked={formData?.medi_re == 1} disabled />
              <span className="mr-2 pr-2">Yes</span>
              <input className="form-check-input mr-2 pl-2" type="checkbox" checked={formData?.medi_re == 0} disabled />
              <span>No</span>
            </div>
            <p>If Yes, attach your medication list or write in your medications below. Please include vitamins and over the counter supplements.</p>

            <div className="docpro_table_1 hipaa_table docpro_table_responsive" style={{ boxShadow: 'none', borderRadius: 0, overflowX: 'auto', paddingBottom: 0 }}>
              <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <th className="text-center" style={{ borderRight: '1px solid var(--border)' }}>Medication Name</th>
                    <th className="text-center" style={{ borderRight: '1px solid var(--border)' }}>Medication Name</th>
                    <th className="text-center">Medication Name</th>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_1}</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_2}</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_3}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_4}</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_5}</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_6}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_7}</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_8}</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_9}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_10}</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_11}</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_12}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_13}</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_14}</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_15}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_16}</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_17}</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20 }}>{formData?.medication_name_18}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {formSize == 'A4' &&
              <div className="spacing_3"></div>
            }
            <h6 className="mb-2 mt-4">PAIN ASSESSMENT</h6>

            <div className="flex items-center mb-1">
              <p className="mr-2 mb-0">Do you have pain?</p>
              <input className="form-check-input mr-2" type="checkbox" checked={formData?.pain == 1} disabled />
              <span className="mr-2 pr-2">Yes</span>
              <input className="form-check-input mr-2 pl-2" type="checkbox" checked={formData?.pain == 0} disabled />
              <span>No</span>
            </div>

            <ul className="docpro_list_1 mb-2">
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 170 }}>If yes, date of onset</p><span className="mx-1">:</span> {exchangeDate(formData?.onset_date)}
              </li>
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 170 }}>If yes, circle the severity</p><span className="mx-1">:</span> {formData?.severity}
              </li>
              <li className="pb-1 flex">
                <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 170 }}>If yes, location of pain</p><span className="mx-1">:</span> {formData?.pain_location}
              </li>
            </ul>

            <div className="docpro_table_1 hipaa_table docpro_table_responsive" style={{ boxShadow: 'none', borderRadius: 0, overflowX: 'auto', paddingBottom: 0 }}>
              <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <th colSpan={1} style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>Medication Review Date</p>
                    </th>
                    <th colSpan={3}>
                      <p className="mb-0" style={{ minHeight: 20 }}></p>
                    </th>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>Practitioner Name</p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20, minWidth: 130 }}></p>
                    </td>
                    <td style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>Practitioner Credentials</p>
                    </td>
                    <td>
                      <p className="mb-0" style={{ minHeight: 20, minWidth: 130 }}></p>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={1} style={{ borderRight: '1px solid var(--border)' }}>
                      <p className="mb-0" style={{ minHeight: 20 }}>Reviewing Practitioner Signature</p>
                    </td>
                    <td colSpan={3}>
                      <p className="mb-0" style={{ minHeight: 60 }}></p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-4">
              <p className="m-0" style={{ fontSize: 13 }}>
                <u><b>Advanced Care Planning Key</b></u>
              </p>
              <p className="mb-0" style={{ fontSize: 13 }}>
                <b>Advance directive:</b> Living will, power of attorney, health care proxy.
              </p>
              <p className="mb-0" style={{ fontSize: 13 }}>
                <b>Actionable medical orders:</b> Physician Orders for Life Sustaining Treatment [POLST], Five Wishes.
              </p>
              <p className="m-0" style={{ fontSize: 13 }}>
                <b>Living will:</b> Legal document denoting preferences for life-sustaining treatment and end-of-life care
              </p>
            </div>

            <div className="flex" style={{ alignItems: 'start' }}>
              <input className="form-check-input" style={{ marginTop: '0.25em' }} type="checkbox" checked={formData?.accept == 1} disabled />
              <label className="form-check-label">
                I acknowledged that this form will be reviewed by the provider and will be placed into the physical medical record and/or scanned into the Electronic Health Record (EMR).
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="docpro_invoice_btns docpro_hide_print">
        <button
          className="docpro_invoice_btn docpro_color3 close_button"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handleCloseWindow();
            } else {
              setFormView();
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </span>
          <span className="docpro_btn_text">Close</span>
        </button>

        <button
          className="docpro_invoice_btn docpro_color1"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handlePrint();
            } else {
              handleFormPrint(formViewId);
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
              <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
              <rect x={128} y={240} width={256} height={208} rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <circle cx={392} cy={184} r={24} fill="currentColor" /> 
            </svg>
          </span>
          <span className="docpro_btn_text">Print</span>
        </button>
      </div>
    </div>
  );
}
